import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthUser } from '../models/auth-user';
import { jwtDecode } from 'jwt-decode';
import { XWareLogService } from '../services/xware-log.service';
declare var google: any;

@Injectable({
  providedIn: 'root',
})
export class CwGapiService {
  redirectUrl = environment.rootUri + '/googleredirect';
  gapiuser: AuthUser;

  constructor(
    private logger: XWareLogService,
    private router: Router
  ) {}

  isGoogleLoaded(): boolean {
    return typeof google !== 'undefined' && google.accounts && google.accounts.id;
  }

  renderButton(btnId: string) {
    if (!this.isGoogleLoaded()) {
      console.warn('Google GSI client not loaded yet');
      return;
    }

    const that = this;
    google.accounts.id.initialize({
      client_id: environment.google_client_id,
      auto_select: true,
      callback: that.loginResponse,
    });

    google.accounts.id.renderButton(document.getElementById(btnId), {
      theme: 'outline',
      size: 'large',
      logo_alignment: 'center',
      width: 225,
    });
  }

  renderButtonSwitch(btnId: string) {
    if (!this.isGoogleLoaded()) {
      return;
    }

    const that = this;
    google.accounts.id.initialize({
      client_id: environment.google_client_id,
      auto_select: true,
      callback: that.loginResponse,
    });

    google.accounts.id.renderButton(document.getElementById(btnId), {
      type: 'icon',
      theme: 'outline',
      shape: 'circle',
      size: 'small',
    });
  }

  loginResponse(response) {
    sessionStorage.setItem('gapi_token', response.credential);
    sessionStorage.setItem('adType', 'gapi');

    const currentURL = window.location.href;
    var redirectUrl = currentURL;
    const rooturi = sessionStorage.getItem('rooturi');
    if (rooturi) {
      redirectUrl = rooturi + '/googleredirect';
    } else {
      const index = currentURL.indexOf('/login');
      if (index > -1) {
        redirectUrl = window.location.href.substring(0, index) + '/googleredirect';
      } else {
        const index = currentURL.indexOf('#');
        if (index > -1) {
          redirectUrl = window.location.href.substring(0, index);
          if (redirectUrl.indexOf('googleredirect') < 0) {
            redirectUrl += '/googleredirect';
            redirectUrl = redirectUrl.replace('//', '/');
          }
        } else {
          redirectUrl = window.location.href + '/googleredirect';
          redirectUrl = redirectUrl.replace('//', '/');
        }
      }
    }

    window.location.href = redirectUrl;
  }

  redirectLogin(bRedirHome: boolean) {
    this.logger.log('redirect home = ' + bRedirHome);
    this.logger.log('redirection is ' + this.redirectUrl);
    const credential = sessionStorage.getItem('gapi_token');
    sessionStorage.removeItem('photo');
    if (!credential) {
      return;
    }
    var responsePayload = jwtDecode(credential);
    this.getUserData(responsePayload);

    this.logger.log('inside redirectLogin');
    if (bRedirHome) {
      this.router.navigate(['/me']);
    }
  }

  reloadAuth() {
    this.logger.log('inside reloadAuth ****');
  }

  logout() {
    this.fnLogout();

    const ob = sessionStorage.getItem('onboarding');
    sessionStorage.clear();
    if (ob === 'Y') {
      sessionStorage.setItem('onboarding', 'Y');
    }
  }

  fnLogout() {
    if (!this.isGoogleLoaded()) {
      return;
    }

    try {
      google.accounts.id.disableAutoSelect();
    } catch (e) {
      this.logger.log('cw-gapi:logout:' + e);
    }
  }

  getUserData(objResponse) {
    this.gapiuser = new AuthUser();

    this.logger.log('Full Name: ' + objResponse['name']);
    this.gapiuser.mail = objResponse['email'];
    this.gapiuser.username = objResponse['name'];
    this.gapiuser.tenantId = objResponse['hd'];

    if (objResponse['email']) {
      sessionStorage.setItem('userPrincipalName', objResponse['email']);
    }

    const picture = objResponse['picture'];
    if (picture && picture !== 'undefined' && picture !== 'null') {
      sessionStorage.setItem('photo', picture);
    } else {
      sessionStorage.removeItem('photo');
    }
  }

  get token() {
    return sessionStorage.getItem('gapi_token');
  }

  isUserSignedIn(): boolean {
    const credential = sessionStorage.getItem('gapi_token');

    let bSignedIn = false;
    try {
      if (credential) {
        bSignedIn = true;
      }
    } catch (e) {}

    return bSignedIn;
  }

  authuser(): any {
    return this.gapiuser;
  }

  switchUser() {}
}

